import type { RewardItem, RewardLevel } from '../types'

/** Сколько призов показываем в карточке уровня; остальные учитываются в подписи «+N». */
export const DISPLAYED_REWARD_ITEMS_MAX = 2

export const getDisplayedRewardItems = (level: RewardLevel): RewardItem[] =>
  level.rewards.slice(0, DISPLAYED_REWARD_ITEMS_MAX)
